export const GET = {value: 'GET', label: 'Get'}
export const PUT = {value: 'PUT', label: 'Put'}
export const POST = {value: 'POST', label: 'Post'}
export const PATCH = {value: 'PATCH', label: 'Patch'}
export const DELETE = {value: 'DELETE', label: 'Delete'}